import React, { useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { KitchenProvider } from "../../context/KitchenContext";
import { AuthContext } from "../../context/AuthContext";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import UserMenuTabs from "../../components/UserMenuTabs/UserMenuTabs";
import ProfileDetails from "../../components/ProfileDetails/ProfileDetails";
import AddKitchen from "../../components/AddKitchen/AddKitchen";
import MyKitchens from "../../components/MyKitchens/MyKitchens";
import Favourites from "../../components/Favourites/Favourites";
import MyBookings from "../../components/MyBookings/MyBookings";
import MyReservations from "../../components/MyReservations/MyReservations";
import Invoices from "../../components/Invoices/Invoices";
import Settings from "../../components/Settings/Settings";
import "./Profile.css";
import Messages from "../../components/Messages/Message";
import Orders from "../../components/Orders/Orders";
import AddRestaurant from "../../components/AddRestaurant/AddRestaurant";
import MyRestaurants from "../../components/MyRestaurants/MyRestaurants";
import AddFoodItem from "../../components/AddFoodItem/AddFoodItem";
import MyFoodItems from "../../components/MyFoodItems/MyFoodItems";
import { FoodProvider } from "../../context/FoodContext";
import {
  FaUserCircle,
  FaInbox,
  FaHeart,
  FaCalendarAlt,
  FaUtensils,
  FaStore,
  FaListAlt,
  FaRegCalendarCheck,
  FaCog,
  FaSignOutAlt,
} from "react-icons/fa";

const Profile = () => {
  const { user, logout } = useContext(AuthContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Sidebar links for mobile dropdown
  const sidebarLinks = [
    { to: "/profile", icon: <FaUserCircle />, label: "Profile Info" },
    { to: "/profile/messages", icon: <FaInbox />, label: "Messages" },
    { to: "/profile/Favourites", icon: <FaHeart />, label: "Favourites" },
    { to: "/profile/my-bookings", icon: <FaCalendarAlt />, label: "Bookings" },
    // {
    //   to: "/profile/my-reservations",
    //   icon: <FaRegCalendarCheck />,
    //   label: "Reservations",
    // },
    {
      to: "/dashboard/today",
      icon: <FaUtensils />,
      label: "Manage Kitchens",
    },
    // { to: "/profile/my-food-item", icon: <FaListAlt />, label: "Food Items" },
    // { to: "/profile/my-restaurants", icon: <FaStore />, label: "Restaurants" },
    // { to: "/profile/orders", icon: <FaListAlt />, label: "Order History" },
    { to: "/profile/settings", icon: <FaCog />, label: "Account Settings" },
  ];

  return (
    <div className="profile-page">
      <Navbar />
      {isMobile && (
        <div className="mobile-profile-menu-wrapper">
          <button
            className="mobile-profile-menu-btn"
            onClick={() => setShowMobileMenu((v) => !v)}
          >
            <FaUserCircle size={22} style={{ marginRight: 8 }} />
            <span>Profile Menu</span>
            <span style={{ marginLeft: 8, fontSize: 18 }}>
              {showMobileMenu ? "▲" : "▼"}
            </span>
          </button>
          <div
            className={`mobile-profile-dropdown${
              showMobileMenu ? " open" : ""
            }`}
          >
            {showMobileMenu && (
              <div className="mobile-profile-dropdown-content">
                {sidebarLinks.map((link) => (
                  <a
                    key={link.to}
                    href={link.to}
                    className="mobile-profile-link"
                    onClick={() => setShowMobileMenu(false)}
                  >
                    <span className="mobile-profile-link-icon">
                      {link.icon}
                    </span>
                    <span className="mobile-profile-link-label">
                      {link.label}
                    </span>
                  </a>
                ))}
                <button
                  className="mobile-profile-link logout"
                  onClick={() => {
                    logout();
                    setShowMobileMenu(false);
                  }}
                >
                  <span className="mobile-profile-link-icon">
                    <FaSignOutAlt />
                  </span>
                  <span className="mobile-profile-link-label">Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      <div className="profile-content">
        <div className="sidebar">{!isMobile && user && <UserMenuTabs />}</div>
        <div className="main-content">
          <KitchenProvider>
            <FoodProvider>
              <Routes>
                <Route path="/" element={<ProfileDetails />} />
                <Route path="messages" element={<Messages />} />
                <Route path="Favourites" element={<Favourites />} />
                <Route path="orders" element={<Orders />} />
                <Route
                  path="add-kitchen"
                  element={<AddKitchen editMode={false} />}
                />
                <Route
                  path="edit-kitchen/:kitchenID"
                  element={<AddKitchen editMode={true} />}
                />
                <Route
                  path="add-food-item"
                  element={<AddFoodItem editMode={false} />}
                />
                <Route
                  path="edit-food-item/:foodID"
                  element={<AddFoodItem editMode={true} />}
                />
                <Route
                  path="add-restaurant"
                  element={<AddRestaurant editMode={false} />}
                />
                <Route
                  path="edit-restaurant/:restaurantID"
                  element={<AddRestaurant editMode={true} />}
                />
                <Route path="my-kitchens" element={<MyKitchens />} />
                <Route path="my-bookings" element={<MyBookings />} />
                <Route path="my-restaurants" element={<MyRestaurants />} />
                <Route path="my-food-item" element={<MyFoodItems />} />
                <Route path="my-reservations" element={<MyReservations />} />
                {/* <Route path="calendar" element={<Calendar />} /> */}
                <Route path="invoices" element={<Invoices />} />
                <Route path="settings" element={<Settings />} />
              </Routes>
            </FoodProvider>
          </KitchenProvider>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Profile;
